import React, { Component } from 'react';
/**
 * Gets the Typeform URL with Facebook pixel parameter if available
 * and UTM parameters from the current URL
 * @returns The Typeform URL with parameters
 */
export const getTypeformUrl = (): string => {
  const baseUrl = 'https://form.typeform.com/to/w1Ld25Qe';
  // Check if we're in a browser environment
  if (typeof document === 'undefined' || typeof window === 'undefined') return baseUrl;
  // Create URL object for building the final URL with parameters
  const typeformUrl = new URL(baseUrl);
  // Get the _fbp cookie if it exists
  const cookies = document.cookie.split(';');
  const fbpCookie = cookies.find(cookie => cookie.trim().startsWith('_fbp='));
  if (fbpCookie) {
    // Extract the value
    const fbpValue = fbpCookie.trim().substring(5); // Remove '_fbp=' prefix
    typeformUrl.searchParams.append('fbp', fbpValue);
  }
  // Get UTM parameters from current URL if they exist
  const currentUrl = new URL(window.location.href);
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  // Add each UTM parameter to the Typeform URL if it exists
  utmParams.forEach(param => {
    const value = currentUrl.searchParams.get(param);
    if (value) {
      typeformUrl.searchParams.append(param, value);
    }
  });
  return typeformUrl.toString();
};